import useMobileView from '@shared/hooks/isMobile'
import { Radio as AntdRadio, ConfigProvider, type RadioProps as AntdRadioProps } from 'antd'

export const Radio = (props: AntdRadioProps) => {
    const isMobile = useMobileView()

    return (
        <ConfigProvider
            theme={{
                components: {
                    Radio: {
                        dotSize: isMobile ? 13 : undefined,
                        radioSize: isMobile ? 25 : undefined
                    }
                }
            }}
        >
            <AntdRadio {...props} />
        </ConfigProvider>
    )
}

Radio.Group = AntdRadio.Group
